module.exports = __webpack_public_path__ + "static/media/appointments.60c7f068.svg";